<template>
  <div>
    <div class="flex flex-col">
      <div class="-my-2 overflow-x-auto sm:-mx-6">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6">
          <div class="shadow overflow-hidden sm:rounded-lg">
            <div class="relative divide-y divide-gray-200">
              <table class="min-w-full divide-y divide-gray-200">
                <ThirdPartyServiceProductListHeader />
                <tbody class="relative">
                  <template v-for="thirdPartyServiceProduct in thirdPartyServiceProducts">
                    <ThirdPartyServiceProductListItem
                      :key="thirdPartyServiceProduct.id"
                      :third-party-service-product="thirdPartyServiceProduct"
                    />
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ThirdPartyServiceProductListHeader from './ThirdPartyServiceProductListHeader.vue';
import ThirdPartyServiceProductListItem from './ThirdPartyServiceProductListItem.vue';

export default {
  components: {
    ThirdPartyServiceProductListHeader,
    ThirdPartyServiceProductListItem,
  },
  props: {
    thirdPartyServiceProducts: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
